module.exports = __webpack_public_path__ + "img/imagen1.fce32a2a.png";